export default __webpack_public_path__ + "alberta-tooth-splint.415eb366f4df3e0d2b4b.svg";